import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { SUBSCRIPTION_FEE } from "@frameworks/web/redux/interfaces/Reports/iSubscriptionFee";
class SubsFeeActions extends OnePlatformCommonActions {
    getSubscriptionFee(subscriptionFee, type) {
        this.dispatch({
            type: SUBSCRIPTION_FEE,
            payload: { subscriptionFee },
            reducerName: type,
        });
    }
}
export default SubsFeeActions;
